// extracted by mini-css-extract-plugin
module.exports = {"registrationTextContainer":"registration-module--registration-text-container--22H3G","formContainer":"registration-module--form-container--38A5V"};